import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "app-auction-images-popup",
  templateUrl: "./auction-images-popup.component.html",
  styleUrls: ["./auction-images-popup.component.scss"],
})
export class AuctionImagesPopupComponent implements OnInit, OnDestroy {
  @Input("images") images;
  @Input("isOld") isOld: boolean;
  @Input("setActiveIndex") setActiveIndex: number;
  @Output() closeModal = new EventEmitter<boolean>();
  @ViewChild("gallery") gallery: ElementRef;

  public activeImage: number = 0;
  public galleryThumbsPosX: number = 0;
  public itemOffsetWidth: number = 0;
  public thumbShapeX: number = 0;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    addEventListener("keydown", this.onKeyDownHandler.bind(this));
    this.moveThumbs(this.setActiveIndex);
  }

  /**
   * key down event handler
   * @param e event
   */
  onKeyDownHandler(e) {
    switch (e.which) {
      case 27: // ESC
        this.closePopup();
        break;

      case 37: // left
        if (this.activeImage > 0) this.moveSlideLeft();
        break;

      case 39: // right
        if (!(this.images.length - 2 < this.activeImage)) this.moveSlideRight();
        break;

      default:
        return; // exit this handler for other keys
    }
    e.preventDefault(); // prevent the default action (scroll / move caret)
  }
  /**
   * Close popup (modal)
   */
  closePopup() {
    this.activeImage = 0;
    this.moveGalleryThumbs();
    this.closeModal.emit(false);
  }
  /**
   * Move slide to left side
   */
  moveSlideLeft() {
    this.activeImage--;
    this.moveGalleryThumbs();
  }
  /**
   * Move slide to right side
   */
  moveSlideRight() {
    this.activeImage++;
    this.moveGalleryThumbs();
  }
  /**
   * Move gallery content inside image gallery wrapper
   */
  moveGalleryThumbs() {
    setTimeout(() => {
      this.itemOffsetWidth = this.gallery.nativeElement.offsetWidth / 7;

      if (this.images.length > 7) {
        if (this.activeImage > this.images.length - 4) {
          this.galleryThumbsPosX =
            this.itemOffsetWidth * -(this.images.length - 7);
        } else if (this.activeImage < 4) {
          this.galleryThumbsPosX = 0;
        } else {
          this.galleryThumbsPosX =
            this.itemOffsetWidth * -(this.activeImage - 3);
        }
      }

      // Move thumbs shape
      this.thumbShapeX = this.itemOffsetWidth * this.activeImage;
    }, 10);
  }
  moveThumbs(index) {
    this.activeImage = index;
    this.moveGalleryThumbs();
  }

  ngOnDestroy(): void {
    removeEventListener("keydown", this.onKeyDownHandler);
  }
}
